module.exports = __webpack_public_path__ + "f4e6784ea60289ba5232d69b114cb213.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/ball-football.png
// module id = 2357
// module chunks = 0